export const AlertSeverity = {
  ERROR: 'error', 
  WARNING: 'warning', 
  SUCCES: 'success', 
  INFO: 'info'
}

export default AlertSeverity;
